import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-096b40e2")

_pushScopeId("data-v-096b40e2")
const _hoisted_1 = { class: "flex items-center justify-center checkout-fail" }
const _hoisted_2 = { class: "flex flex-column items-center justify-center" }
const _hoisted_3 = { class: "h1" }
const _hoisted_4 = { class: "my4 center" }
const _hoisted_5 = { class: "h4" }
const _hoisted_6 = { class: "h4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('checkout.fail.title')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('checkout.fail.charged', {
              value: 'contact@getremotefun.com'
            })), 1),
        _createVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('checkout.fail.notCharged', {
              value: 'contact@getremotefun.com'
            })), 1)
      ])
    ])
  ]))
})